import React, { useEffect } from 'react';
import { ItemCreation } from '~/Components/ItemCreation';
import { useEventCreate, usePageTitle } from './hooks';
import { useTranslation } from 'react-i18next';
import { PrivateLayout } from '~/Layout/PrivateLayout';
import { ExtendedEventGroup } from './ExtendedEventGroup.model';
import { useProvider } from '~/Hooks';
import { Segment } from '~/Helpers/Segment.helper';
import { SegmentName } from '~/Constants/Segment.constants';
import { EventType } from '~/Models/DTO/Event.model';
import { useEventValidationSchema } from './hooks/useEventValidationSchema';

export const EventCreate = () => {
  const {
    isEditEventGroup,
    eventType,
    showFormErrors,
    eventGroup,
    validate,
    isLoading,
    listItems,
    headers,
    onSave,
    error,
    backgroundColor,
  } = useEventCreate();
  const { t } = useTranslation();
  const { pageTitle } = usePageTitle({
    eventType,
    isEditEventGroup,
    eventGroupName: eventGroup?.name,
  });
  const { validationSchema, validationWrapper } = useEventValidationSchema(validate);
  const { currentProvider, isUsingThePartnerTool } = useProvider();

  useEffect(() => {
    if (!eventType || !currentProvider) {
      return;
    }
    const { email, domain } = currentProvider;

    Segment.track(isEditEventGroup ? SegmentName.EDIT_EVENT_GROUP : SegmentName.CREATE_EVENT, {
      email,
      domain,
      eventType,
      isUsingPartnerPortal: isUsingThePartnerTool,
    });
  }, [isEditEventGroup, eventType, currentProvider, location.pathname]);

  const shouldShowAlert = !isEditEventGroup && eventType === EventType.FREE_TRAINING;

  return (
    <PrivateLayout
      title={pageTitle}
      actionName={t('app.save')}
      onActionTaken={onSave}
      actionDisabled={isLoading}
      cancelInsteadOfBack
      backgroundColor={backgroundColor}
      articleLink="app.freeTrainingLink"
      isNew={shouldShowAlert}
    >
      <ItemCreation<ExtendedEventGroup>
        listItems={listItems}
        headers={headers}
        onSave={onSave}
        initialValues={eventGroup}
        validate={validationWrapper}
        networkError={error}
        isLoading={isLoading}
        validationSchema={validationSchema as any}
        showFormErrors={showFormErrors}
        validateOnMount
      />
    </PrivateLayout>
  );
};
